import React from 'react';

import type { Asset } from '../../../../app/entities/asset';

import styles from './choose-video-version.module.scss';
type VideoCompareProps = {
  versions: Asset[];
  onSelect: (version: string) => void;
};

export const ChooseVideoVersion: React.FC<VideoCompareProps> = ({ versions, onSelect }) => (
  <div className={styles['container']}>
    <div className={styles['header']}>Versions to compare</div>

    <div className={styles['modal-container']}>
      {versions?.length ? (
        versions.map((asset) => (
          <div
            className={styles['version-item-wrapper']}
            key={asset._id}
            onClick={() => onSelect(asset._id)}
          >
            <div className={styles['version-item']}>
              <div className={styles['version-title']}>{asset.name}</div>
              <div className={styles['version']}>V{asset.version}</div>
            </div>
          </div>
        ))
      ) : (
        // TODO: Add a proper message and style it
        <>There are no other versions for comparison</>
      )}
    </div>
  </div>
);
